module.exports = __webpack_public_path__ + "static/img/product-3.875ba80.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/images/product-3.png
// module id = sIIu
// module chunks = 1